import * as React from 'react';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';

export default function MaterialUIPickers() {


    const [value, setValue] = React.useState(new Date('2017-01-01T21:11:54'));
  
    const handleChange = (newValue) => {
      setValue(newValue);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <MobileDatePicker
            label="Gyermek születési dátuma"
            inputFormat="yyyy/MM/dd"
            value={value}
            onChange={handleChange}
            renderInput={(params) => <TextField {...params} />}
        />
        </LocalizationProvider>
    );
  }